import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiHome, 
  FiUserPlus, 
  FiGift, 
  FiUser, 
  FiFile, 
  FiClock, 
  FiCreditCard, 
  FiEdit, 
  FiShare2, 
  FiPlay,
  FiChevronDown,
  FiChevronUp,
  FiUpload,
  FiFilm,
  FiX
} from 'react-icons/fi';
import { MdPlaylistPlay } from 'react-icons/md';
import { FaRupeeSign } from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const [openMenus, setOpenMenus] = useState({
    myAccount: false,
  });

  // Prevent background scroll when mobile submenu is open
  useEffect(() => {
    if (openMenus.myAccount) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [openMenus.myAccount]);

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  const menuItems = [
    {
      name: 'Home',
      icon: <FiHome className="text-lg sm:text-xl" />,
      path: '/home',
      isActive: currentPath === '/home',
      isEssential: true,
    },
    {
      name: 'Commission',
      icon: <FaRupeeSign className="text-lg sm:text-xl" />,
      path: '/commission',
      isActive: currentPath === '/commission',
      isEssential: true,
    },
    {
      name: 'Invite',
      icon: <FiUserPlus className="text-lg sm:text-xl" />,
      path: '/invite',
      isActive: currentPath === '/invite',
      isEssential: true,
    },
    {
      name: 'Gift',
      icon: <FiGift className="text-lg sm:text-xl" />,
      path: '/gift',
      isActive: currentPath === '/gift',
      isEssential: true,
    },
    {
      name: 'My A/c',
      icon: <FiUser className="text-lg sm:text-xl" />,
      path: null,
      isActive: currentPath.startsWith('/account'),
      isEssential: true,
      submenu: [
        {
          name: 'My Files',
          icon: <FiFile className="text-lg" />,
          path: '/my-videos',
          isActive: currentPath === '/my-videos',
        },
        {
          name: 'History',
          icon: <FiClock className="text-lg" />,
          path: '/history',
          isActive: currentPath === '/history',
        },
        {
          name: 'Task',
          icon: <FiEdit className="text-lg" />,
          path: '/task',
          isActive: currentPath === '/task',
        },
        {
          name: 'Playlist',
          icon: <MdPlaylistPlay className="text-lg" />,
          path: '/playlist',
          isActive: currentPath === '/playlist',
        },
        {
          name: 'Upload Video',
          icon: <FiUpload className="text-lg" />,
          path: '/upload',
          isActive: currentPath === '/upload',
        },
        {
          name: 'Upload Photo',
          icon: <FiUpload className="text-lg" />,
          path: '/photo-upload',
          isActive: currentPath === '/photo-upload',
        },
        {
          name: 'Settings',
          icon: <FiCreditCard className="text-lg" />,
          path: '/setting',
          isActive: currentPath === '/setting',
        },
      ],
    },
  ];

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
      // Close the submenu on mobile after navigation
      setOpenMenus((prev) => ({
        ...prev,
        myAccount: false,
      }));
    }
  };

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:block w-64 h-screen bg-white shadow-md fixed left-0 top-0 pt-16 overflow-y-auto dark:bg-gray-800">
        <div className="flex flex-col p-4">
          <div className="mb-6">
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-2 dark:text-gray-400">
              Menu
            </h3>
            <div className="space-y-1">
              {menuItems.map((item) => (
                <div key={item.name}>
                  <div
                    onClick={() => {
                      if (item.submenu) {
                        toggleMenu(item.name.toLowerCase().replace(' ', ''));
                      } else {
                        handleNavigation(item.path);
                      }
                    }}
                    className={`flex items-center px-3 py-2 rounded-lg transition-colors cursor-pointer ${
                      item.isActive
                        ? 'bg-blue-50 text-blue-600 dark:bg-blue-900 dark:text-blue-200'
                        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700'
                    }`}
                  >
                    <span className="mr-3">{item.icon}</span>
                    <span className="font-medium flex-grow">{item.name}</span>
                    {item.submenu && (
                      <span>
                        {openMenus[item.name.toLowerCase().replace(' ', '')] ? (
                          <FiChevronUp className="text-gray-500" />
                        ) : (
                          <FiChevronDown className="text-gray-500" />
                        )}
                      </span>
                    )}
                  </div>
                  {item.submenu && openMenus[item.name.toLowerCase().replace(' ', '')] && (
                    <div className="ml-6 mt-1 space-y-1">
                      {item.submenu.map((subItem) => (
                        <div
                          key={subItem.name}
                          onClick={() => handleNavigation(subItem.path)}
                          className={`flex items-center px-3 py-2 rounded-lg transition-colors cursor-pointer ${
                            subItem.isActive
                              ? 'bg-blue-50 text-blue-600 dark:bg-blue-900 dark:text-blue-200'
                              : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700'
                          }`}
                        >
                          <span className="mr-3">{subItem.icon}</span>
                          <span className="text-sm">{subItem.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </div>

      {/* Mobile Bottom Navbar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white shadow-md dark:bg-gray-800 z-50 pb-safe sm:pb-2" style={{paddingBottom: 'env(safe-area-inset-bottom, 0px)'}}>
        <div className="flex justify-around items-center py-2 gap-2">
          {menuItems
            .filter((item) => item.isEssential)
            .map((item) => (
              <div
                key={item.name}
                onClick={() => {
                  if (item.name === 'My A/c') {
                    toggleMenu('myAccount');
                  } else {
                    handleNavigation(item.path);
                  }
                }}
                className={`flex flex-col items-center px-2 py-2 min-h-[44px] cursor-pointer w-full max-w-[80px] sm:max-w-[100px] ${
                  item.isActive
                    ? 'text-blue-600 dark:text-blue-200'
                    : 'text-gray-600 dark:text-gray-300'
                }`}
                aria-label={item.name}
              >
                <span className="text-base sm:text-lg">{item.icon}</span>
                <span className="text-[10px] sm:text-xs mt-1 leading-tight text-center break-words">{item.name}</span>
              </div>
            ))}
        </div>
      </div>

      {/* Mobile Submenu Overlay for My Account */}
      {openMenus.myAccount && (
        <div className="md:hidden fixed inset-0 bg-black bg-opacity-60 z-50 flex items-end animate-slideUp overflow-x-hidden">
          <div className="w-full bg-white dark:bg-gray-800 rounded-t-xl shadow-2xl max-h-[85vh] overflow-y-auto" style={{maxHeight: 'calc(85vh - env(safe-area-inset-bottom, 0px))'}}>
            <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 sticky top-0 z-10">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-100">My Account</h3>
              <button
                onClick={() => toggleMenu('myAccount')}
                className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
                aria-label="Close My Account submenu"
              >
                <FiX className="text-lg sm:text-xl text-gray-600 dark:text-gray-300" />
              </button>
            </div>
            <div className="flex flex-col p-2 space-y-2">
              {menuItems
                .find((item) => item.name === 'My A/c')
                .submenu.map((subItem, index) => (
                  <div
                    key={subItem.name}
                    onClick={() => {
                      handleNavigation(subItem.path);
                      setOpenMenus((prev) => ({ ...prev, myAccount: false }));
                    }}
                    className={`flex items-center px-4 py-3 rounded-lg transition-colors cursor-pointer border-l-4 mb-1 min-h-[44px] w-full ${
                      subItem.isActive
                        ? 'bg-blue-50 text-blue-600 dark:bg-blue-900 dark:text-blue-200 border-blue-500'
                        : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700 border-transparent hover:border-gray-300 dark:hover:border-gray-600'
                    } animate-slideUp`}
                    style={{ animationDelay: `${index * 0.05}s` }}
                    aria-label={`Navigate to ${subItem.name}`}
                  >
                    <span className="mr-3 text-base sm:text-lg">{subItem.icon}</span>
                    <span className="text-sm sm:text-base font-medium break-words">{subItem.name}</span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default Sidebar;